import type { DotTheme } from '../../types';

export const deviceWidth = {
  mobileS: 320,
  mobileM: 375,
  mobileL: 425,
  tablet: 768,
  laptop: 1024,
  laptopL: 1440,
  desktop: 2560,
};

/**
 * Font weights:
 *
 * Montserrat: 400, 500, 600, 700
 * OCRB: 400, 600
 */

export const theme: DotTheme = {
  isRtl: false,
  fontSizes: {
    xs: '0.75rem',
    s: '0.875rem', // 14px
    m: '1rem',
    l: '1.125rem',
    xxl: '2rem',
  },
  lineHeights: {
    xxs: '1.25rem',
    xs: '1.375rem',
    s: '1.5rem',
    m: '1.75rem',
    xl: '2.875rem',
    xxl: '3.625rem',
  },
  fontFamily: {
    montserrat: 'Montserrat, sans-serif',
    ocrb: 'OCRB, monospace',
  },
  colors: {
    emeraldGreen: {
      100: '#42BE65',
      80: '#68CB84', // primaryButtonHover
      50: '#A0DEB2',
      30: '#C6ECD1',
      10: '#ECF8F0',
    },
    oxfordBlue: {
      100: '#021B41', // primaryBlue,
      80: '#354967',
      50: '#808DA0', // gray
      30: '#B3BBC6',
      10: '#E6E8EC',
    },
    aeroBlue: {
      100: '#85B7E2',
      80: '#9DC5E8',
      50: '#C2DBF0',
      30: '#DAE9F6',
      10: '#F3F8FC',
    },
    erieBlack: {
      100: '#131313',
      80: '#424242',
      50: '#898989',
      30: '#B8B8B8',
      10: '#E7E7E7',
    },
    slateGray: {
      100: '#7C878E',
      80: '#BDC3C6',
      50: '#D8DBDD',
      30: '#EAECEE',
      10: '#F2F3F4',
    },
    tiffanyGreen: {
      100: '#00BFB2',
      50: '#80DFD8',
      30: '#B2ECE8',
      10: '#E6F9F7',
    },
    alertRed: {
      100: '#E5352B',
      80: '#EA5D55',
      10: '#FCEBEA',
    },
    carrotOrange: {
      100: '#EF9020',
    },
    white: '#FFFFFF',
    whiteLight: '#F8FBFB', // loading text overlay
    transparent: 'rgba(0,0,0,0)',
    shadows: {
      emeraldGreen: {
        20: 'rgba(66, 190, 101, 0.2)',
      },
      erieBlack: {
        10: 'rgba(19, 19, 19, 0.1)',
        30: 'rgba(19, 19, 19, 0.3)',
        50: 'rgba(19, 19, 19, 0.5)', // auto capture overlay
        80: 'rgba(19, 19, 19, 0.8)', // modal overlay
      },
      ctaPrimary: {
        24: 'rgba(0, 164, 153, 0.24)',
      },
      gray: {
        40: 'rgba(3, 25, 58, 0.4)',
      },
      blue: {
        100: '#03193A',
      },
      white: {
        80: 'rgba(255, 255, 255, 0.8)',
      },
      slateGray: {
        10: 'rgba(19, 19, 19, 0.1)',
        50: 'rgba(242, 243, 244, 0.5)',
      },
      oxfordBlue: {
        10: 'rgba(2, 27, 65, 0.1)',
        30: 'rgba(179, 187, 198, 0.3)', // Oxford Blue 30 - 30%
        80: 'rgba(128, 141, 160, 0.8)', // Oxford Blue 50 - 80%
      },
    },
  },
  devices: {
    mobileS: `${deviceWidth.mobileS}px`,
    mobileM: `${deviceWidth.mobileM}px`,
    mobileL: `${deviceWidth.mobileL}px`,
    tablet: `${deviceWidth.tablet}px`,
    laptop: `${deviceWidth.laptop}px`,
    laptopL: `${deviceWidth.laptopL}px`,
    desktop: `${deviceWidth.desktop}px`,
  },
  dimensions: {
    containerMaxWidth: '75rem',
    buttonBarHeight: '3.75rem',
    stepHeaderHeight: '3.125rem',
    navBarHeight: '5rem',
  },
};
